import numerator from '../../plugins/jquery-numerator.js';


//=========== カンマ削除 ============//
function removeComma(number) {
  var removed = number.replace(/,/g, '');
  return parseInt(removed, 10);
}


  if (window.matchMedia( "(max-width: 768px)" ).matches) {
    var viewFactor_num_01 = '0.2';
  } else {
    var viewFactor_num_01 = '1';
  }

/* ----------------------------
  シェア率・官公庁案件割合のセクションのカウントアップ
------------------------------*/
ScrollReveal().reveal('.animateBottom_grah_count_01', {
  duration: 1200,
  distance: '100px',
  origin: 'bottom',
  viewFactor: viewFactor_num_01,
  afterReveal: function (el) {
    
    let count_up_01 = $("#count-up-01 .count-up-max").text();
    count_up_01 = removeComma(count_up_01); 
    $('#count-up-01 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_01, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_02 = $("#count-up-02 .count-up-max").text();
    count_up_02 = removeComma(count_up_02); 
    $('#count-up-02 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_02, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_39 = $("#count-up-39 .count-up-max").text();
    count_up_39 = removeComma(count_up_39); 
    $('#count-up-39 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_39, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
  }
});

/* ----------------------------
  会社の歴史のセクションのカウントアップ
------------------------------*/
ScrollReveal().reveal('.animateBottom_grah_count_02', {
  duration: 1200,
  distance: '100px',
  origin: 'bottom',
  viewFactor: viewFactor_num_01,
  afterReveal: function (el) {
    let count_up_03 = $("#count-up-03 .count-up-max").text();
    count_up_03 = removeComma(count_up_03); 
    $('#count-up-03 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_03, // どこまでカウントアップするか
      //delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    let count_up_40 = $("#count-up-40 .count-up-max").text();
    count_up_40 = removeComma(count_up_40); 
    $('#count-up-40 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_40, // どこまでカウントアップするか
      //delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
  }
});

/* ----------------------------
事業割合のセクションのカウントアップ 円グラフ生成
------------------------------*/
ScrollReveal().reveal('.animateBottom_grah_circle', {
  duration: 1200,
  distance: '100px',
  origin: 'bottom',
  viewFactor: '0.4',
  afterReveal: function (el) {

    let circleAll = 100;
    //let circleAll = $("#circle-all .count-up-max").text();
    // circleAll = removeComma(circleAll); 
    // $('#circle-all .count-up').numerator( {
    //   easing: 'linear', // アニメーションの動き
    //   duration: 1000, // アニメーションの時間
    //   toValue: circleAll, // どこまでカウントアップするか
    //   delimiter: ',', // ３桁ごとに区切る値
    //   rounding: 0 // 小数点以下の桁数
    // });

    let circle_data_01  = $("#circle-data-01 .count-up-max").text();
    $('#circle-data-01 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: removeComma(circle_data_01), // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    circle_data_01 = removeComma(circle_data_01) / circleAll * 100;
    circle_data_01 = Math.trunc(circle_data_01);
    let circle_data_title_01 = $("#circle-data-title-01").text();



    let circle_data_02  = $("#circle-data-02 .count-up-max").text();
    $('#circle-data-02 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: removeComma(circle_data_02), // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    circle_data_02 = removeComma(circle_data_02) / circleAll * 100;
    circle_data_02 = Math.trunc(circle_data_02);
    let circle_data_title_02 = $("#circle-data-title-02").text();



    let circle_data_03  = $("#circle-data-03 .count-up-max").text();
    $('#circle-data-03 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: removeComma(circle_data_03), // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    circle_data_03 = removeComma(circle_data_03) / circleAll * 100;
    circle_data_03 = Math.trunc(circle_data_03);
    let circle_data_title_03 = $("#circle-data-title-03").text();



    let circle_data_04  = $("#circle-data-04 .count-up-max").text();
    $('#circle-data-04 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: removeComma(circle_data_04), // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    circle_data_04 = removeComma(circle_data_04) / circleAll * 100;
    circle_data_04 = Math.trunc(circle_data_04);
    let circle_data_title_04 = $("#circle-data-title-04").text();



    let circle_data_05  = $("#circle-data-05 .count-up-max").text();
    $('#circle-data-05 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: removeComma(circle_data_05), // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    circle_data_05 = removeComma(circle_data_05) / circleAll * 100;
    circle_data_05 = Math.trunc(circle_data_05);
    let circle_data_title_05 = $("#circle-data-title-05").text();

    /*------------------
    グラフキャンバス作成実行 
    -------------------*/

    var ctx = document.getElementById("chart01");//グラフを描画したい場所のid
    var chart = new Chart(ctx,{
      type:'doughnut',//グラフのタイプ
      data:{//グラフのデータ
        labels:[circle_data_title_01, circle_data_title_02, circle_data_title_03, circle_data_title_04, circle_data_title_05],//データの名前
        datasets:[{
            //label:"",//グラフのタイトル
            backgroundColor:["#E60012","#246C34","#6C4F24","#24356C","#7E9FCA"],//グラフの背景色
            data:[circle_data_01, circle_data_02, circle_data_03, circle_data_04,circle_data_05],//データ
            borderWidth: 7
          }]
      },
      options:{//グラフのオプション
        maintainAspectRatio: false,//CSSで大きさを調整するため、自動縮小をさせない
        cutoutPercentage: 65,//中央からの空円の太さ。グラフの太さ変更
        legend:{
          display:false//グラフの説明を表示
        },
        //グラフへカーソルを合わせた際の詳細表示の設定
        tooltips:false,
        // {
        //   callbacks:{
        //       label: function (tooltipItem, data) {
        //     return data.labels[tooltipItem.index]+ ": "+ data.datasets[0].data[tooltipItem.index] + "%";//%を最後につける
        //   }
        //   },    
        // },
        //上部タイトル表示の設定
        title:{
          display: false,
        },
      }
    });
  }
});

/* ----------------------------
社員数のセクションのカウントアップ
------------------------------*/
ScrollReveal().reveal('.animateBottom_grah_bar_01', {
  duration: 1200,
  distance: '100px',
  origin: 'bottom',
  viewFactor: '0.1',
  afterReveal: function (el) {

    let all_op = $("#count-up-04 .count-up-max").text();
    all_op = removeComma(all_op);

    let count_up_04 = $("#count-up-04 .count-up-max").text();
    count_up_04 = removeComma(count_up_04);
    $('#count-up-04 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_04, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let regular_op = $(".regular-op .ob-graph-num2-max").text();
    regular_op = removeComma(regular_op);
    regular_op = regular_op / all_op * 100;
    regular_op = parseInt(regular_op, 10);
    //比率上限値設定
    regular_op = regular_op > 83 ? 83 : regular_op;
    let regular_op_width = 'calc(' + regular_op + '% - 5px)';

    $(".regular-op").css('width',regular_op_width);
    $(".regular-op").css('display','block');
    $(".bar3").addClass('barAnimation');

    let count_up_05 = $("#count-up-05 .ob-graph-num2-max").text();
    count_up_05 = removeComma(count_up_05);
    $('#count-up-05 .ob-graph-num2').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_05, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    let count_up_05_2 = $("#count-up-05-2 .ob-graph-num2-max").text();
    count_up_05_2 = removeComma(count_up_05_2);
    $('#count-up-05-2 .ob-graph-num2').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_05_2, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    //console.log(regular_op);

    let emergency_op = 'calc(100% - ' + regular_op + '% - 5px)';

    $(".emergency-op").css('width',emergency_op);
    $(".emergency-op").css('display','block');
    $(".bar4").addClass('barAnimation');

    let count_up_06 = $("#count-up-06 .ob-graph-num2-max").text();
    count_up_06 = removeComma(count_up_06);
    $('#count-up-06 .ob-graph-num2').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_06, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    let count_up_06_2 = $("#count-up-06-2 .ob-graph-num2-max").text();
    count_up_06_2 = removeComma(count_up_06_2); 
    $('#count-up-06-2 .ob-graph-num2').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_06_2, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });


    // let count_up_07 = $("#count-up-07 .count-up-max").text();
    // count_up_07 = removeComma(count_up_07); 
    // $('#count-up-07 .count-up').numerator( {
    //   easing: 'linear', // アニメーションの動き
    //   duration: 1000, // アニメーションの時間
    //   toValue: count_up_07, // どこまでカウントアップするか
    //   delimiter: ',', // ３桁ごとに区切る値
    //   rounding: 0 // 小数点以下の桁数
    // });

    // let count_up_08 = $("#count-up-08 .count-up-max").text();
    // count_up_08 = removeComma(count_up_08); 
    // $('#count-up-08 .count-up').numerator( {
    //   easing: 'linear', // アニメーションの動き
    //   duration: 1000, // アニメーションの時間
    //   toValue: count_up_08, // どこまでカウントアップするか
    //   delimiter: ',', // ３桁ごとに区切る値
    //   rounding: 0 // 小数点以下の桁数
    // });

    // let count_up_09 = $("#count-up-09 .count-up-max").text();
    // count_up_09 = removeComma(count_up_09); 
    // $('#count-up-09 .count-up').numerator( {
    //   easing: 'linear', // アニメーションの動き
    //   duration: 1000, // アニメーションの時間
    //   toValue: count_up_09, // どこまでカウントアップするか
    //   delimiter: ',', // ３桁ごとに区切る値
    //   rounding: 0 // 小数点以下の桁数
    // });



    let all_op2 = 100;

    let count_up_41 = $("#count-up-41 .ob-graph-num2-max").text();
    count_up_41 = removeComma(count_up_41); 
    $('#count-up-41 .ob-graph-num2').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_41, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let young_op = $(".young-op .ob-graph-num2-max").text();
    young_op = removeComma(young_op);
    young_op = young_op / all_op2 * 100;
    young_op = parseInt(young_op, 10)
    let young_op_width = 'calc(' + young_op + '% - 5px)';

    $(".young-op").css('width',young_op_width);
    $(".young-op").css('display','block');
    $(".bar7").addClass('barAnimation');


    let count_up_42 = $("#count-up-42 .ob-graph-num2-max").text();
    count_up_42 = removeComma(count_up_42); 
    $('#count-up-42 .ob-graph-num2').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_42, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let middle_op = $(".middle-op .ob-graph-num2-max").text();
    middle_op = removeComma(middle_op);
    middle_op = middle_op / all_op2 * 100;
    middle_op = parseInt(middle_op, 10)
    let middle_op_width = 'calc(' + middle_op + '% - 5px)';

    $(".middle-op").css('width',middle_op_width);
    $(".middle-op").css('display','block');
    $(".bar8").addClass('barAnimation');



    let count_up_43 = $("#count-up-43 .ob-graph-num2-max").text();
    count_up_43 = removeComma(count_up_43); 
    $('#count-up-43 .ob-graph-num2').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_43, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let older_op = $(".older-op .ob-graph-num2-max").text();
    older_op = removeComma(older_op);
    older_op = older_op / all_op2 * 100;
    older_op = parseInt(older_op, 10)
    let older_op_width = 'calc(' + older_op + '% - 5px)';

    $(".older-op").css('width',older_op_width);
    $(".older-op").css('display','block');
    $(".bar9").addClass('barAnimation');
  }
});


/* ----------------------------
  働きやすさ・年間休日、産休・育休、平均勤続年数のセクションのカウントアップ
------------------------------*/
ScrollReveal().reveal('.animateBottom_grah_count_03', {
  duration: 1200,
  distance: '100px',
  origin: 'bottom',
  viewFactor: viewFactor_num_01,
  afterReveal: function (el) {
    
    let count_up_10 = $("#count-up-10 .count-up-max").text();
    count_up_10 = removeComma(count_up_10); 
    $('#count-up-10 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_10, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_11 = $("#count-up-11 .count-up-max").text();
    count_up_11 = removeComma(count_up_11); 
    $('#count-up-11 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_11, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_12 = $("#count-up-12 .count-up-max").text();
    count_up_12 = removeComma(count_up_12); 
    $('#count-up-12 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_12, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_13 = $("#count-up-13 .count-up-max").text();
    count_up_13 = removeComma(count_up_13); 
    $('#count-up-13 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_13, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_14 = $("#count-up-14 .count-up-max").text();
    count_up_14 = removeComma(count_up_14); 
    $('#count-up-14 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_14, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
  }
});


/* ----------------------------
  出身地のセクションのカウントアップ
------------------------------*/
ScrollReveal().reveal('.animateBottom_grah_count_04', {
  duration: 1200,
  distance: '100px',
  origin: 'bottom',
  viewFactor: '0.1',
  afterReveal: function (el) {
    
    let count_up_15 = $("#count-up-15 .count-up-max").text();
    count_up_15 = removeComma(count_up_15); 
    $('#count-up-15 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_15, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_16 = $("#count-up-16 .count-up-max").text();
    count_up_16 = removeComma(count_up_16); 
    $('#count-up-16 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_16, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_17 = $("#count-up-17 .count-up-max").text();
    count_up_17 = removeComma(count_up_17); 
    $('#count-up-17 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_17, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_18 = $("#count-up-18 .count-up-max").text();
    count_up_18 = removeComma(count_up_18); 
    $('#count-up-18 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_18, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_19 = $("#count-up-19 .count-up-max").text();
    count_up_19 = removeComma(count_up_19); 
    $('#count-up-19 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_19, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_20 = $("#count-up-20 .count-up-max").text();
    count_up_20 = removeComma(count_up_20); 
    $('#count-up-20 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_20, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_21 = $("#count-up-21 .count-up-max").text();
    count_up_21 = removeComma(count_up_21); 
    $('#count-up-21 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_21, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_22 = $("#count-up-22 .count-up-max").text();
    count_up_22 = removeComma(count_up_22); 
    $('#count-up-22 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_22, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_23 = $("#count-up-23 .count-up-max").text();
    count_up_23 = removeComma(count_up_23); 
    $('#count-up-23 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_23, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_24 = $("#count-up-24 .count-up-max").text();
    count_up_24 = removeComma(count_up_24); 
    $('#count-up-24 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_24, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_25 = $("#count-up-25 .count-up-max").text();
    count_up_25 = removeComma(count_up_25); 
    $('#count-up-25 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_25, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_26 = $("#count-up-26 .count-up-max").text();
    count_up_26 = removeComma(count_up_26); 
    $('#count-up-26 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_26, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });


  
    let circleAll2 = 100;
    let circle_data_24  = $("#count-up-24 .count-up-max").text();
    $('#count-up-24 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: removeComma(circle_data_24), // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    circle_data_24 = removeComma(circle_data_24) / circleAll2 * 100;
    circle_data_24 = Math.trunc(circle_data_24);

    let circle_data_25  = $("#count-up-25 .count-up-max").text();
    $('#count-up-25 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: removeComma(circle_data_25), // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    circle_data_25 = removeComma(circle_data_25) / circleAll2 * 100;
    circle_data_25 = Math.trunc(circle_data_25);

    let circle_data_26  = $("#count-up-26 .count-up-max").text();
    $('#count-up-26 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: removeComma(circle_data_26), // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    circle_data_26 = removeComma(circle_data_26) / circleAll2 * 100;
    circle_data_26 = Math.trunc(circle_data_26);


    let count_up_33 = $("#count-up-33 .count-up-max").text();
    count_up_33 = removeComma(count_up_33); 
    $('#count-up-33 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_33, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_34 = $("#count-up-34 .count-up-max").text();
    count_up_34 = removeComma(count_up_34); 
    $('#count-up-34 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_34, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
   
  }
});



/* ----------------------------
  平均通勤時間・通勤方法・平均退社時間のセクションのカウントアップ
------------------------------*/
ScrollReveal().reveal('.animateBottom_grah_count_05', {
  duration: 1200,
  distance: '100px',
  origin: 'bottom',
  viewFactor: viewFactor_num_01,
  afterReveal: function (el) {
    
    let count_up_27 = $("#count-up-27 .count-up-max").text();
    count_up_27 = removeComma(count_up_27); 
    $('#count-up-27 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_27, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_28 = $("#count-up-28 .count-up-max").text();
    count_up_28 = removeComma(count_up_28); 
    $('#count-up-28 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_28, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_29 = $("#count-up-29 .count-up-max").text();
    count_up_29 = removeComma(count_up_29); 
    $('#count-up-29 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_29, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_30 = $("#count-up-30 .count-up-max").text();
    count_up_30 = removeComma(count_up_30); 
    $('#count-up-30 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_30, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_31 = $("#count-up-31 .count-up-max").text();
    count_up_31 = removeComma(count_up_31); 
    $('#count-up-31 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_31, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_32 = $("#count-up-32 .count-up-max").text();
    count_up_32 = removeComma(count_up_32); 
    $('#count-up-32 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_32, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

  }
});


/* ----------------------------
  平均通勤時間・通勤方法・平均退社時間のセクションのカウントアップ
------------------------------*/
ScrollReveal().reveal('.animateBottom_grah_count_06', {
  duration: 1200,
  distance: '100px',
  origin: 'bottom',
  viewFactor: viewFactor_num_01,
  afterReveal: function (el) {
    


    let count_up_35 = $("#count-up-35 .count-up-max").text();
    count_up_35 = removeComma(count_up_35); 
    $('#count-up-35 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_35, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_36 = $("#count-up-36 .count-up-max").text();
    count_up_36 = removeComma(count_up_36); 
    $('#count-up-36 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_36, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_37 = $("#count-up-37 .count-up-max").text();
    count_up_37 = removeComma(count_up_37); 
    $('#count-up-37 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_37, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

    let count_up_38 = $("#count-up-38 .count-up-max").text();
    count_up_38 = removeComma(count_up_38); 
    $('#count-up-38 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_38, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });

  }
});



/* ----------------------------
  出身地のセクションのカウントアップ
------------------------------*/
ScrollReveal().reveal('.animateBottom_grah_count_07', {
  duration: 1200,
  distance: '100px',
  origin: 'bottom',
  viewFactor: '0.1',
  afterReveal: function (el) {

    let circleAll2 = 51;
    let circle_data_44  = $("#count-up-44 .count-up-max").text();
    $('#count-up-44 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: removeComma(circle_data_44), // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    circle_data_44 = removeComma(circle_data_44) / circleAll2 * 100;
    circle_data_44 = Math.trunc(circle_data_44);
    

    let circle_data_45  = $("#count-up-45 .count-up-max").text();
    $('#count-up-45 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: removeComma(circle_data_45), // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    circle_data_45 = removeComma(circle_data_45) / circleAll2 * 100;
    circle_data_45 = Math.trunc(circle_data_45);


    let circle_data_46  = $("#count-up-46 .count-up-max").text();
    $('#count-up-46 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: removeComma(circle_data_46), // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    circle_data_46 = removeComma(circle_data_46) / circleAll2 * 100;
    circle_data_46 = Math.trunc(circle_data_46);


    let circle_data_47  = $("#count-up-47 .count-up-max").text();
    $('#count-up-47 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: removeComma(circle_data_47), // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
    circle_data_47 = removeComma(circle_data_47) / circleAll2 * 100;
    circle_data_47 = Math.trunc(circle_data_47);

    /*------------------
    グラフキャンバス作成実行 
    -------------------*/
    var ctx2 = document.getElementById("chart02");//グラフを描画したい場所のid
    var chart2 = new Chart(ctx2,{
      type:'doughnut',//グラフのタイプ
      data:{//グラフのデータ
        // labels:[circle_data_title_01, circle_data_title_02, circle_data_title_03, circle_data_title_04, circle_data_title_05],//データの名前
        datasets:[{
            //label:"",//グラフのタイトル
            backgroundColor:["#E60012","#6C4F24","#246C34", "#24356C"],//グラフの背景色
            data:[circle_data_44, circle_data_45, circle_data_46, circle_data_47],//データ
            borderWidth: 11
          }]
      },
      options:{//グラフのオプション
        maintainAspectRatio: false,//CSSで大きさを調整するため、自動縮小をさせない
        cutoutPercentage: 60,//中央からの空円の太さ。グラフの太さ変更
        legend:{
          display:false//グラフの説明を表示
        },
        //グラフへカーソルを合わせた際の詳細表示の設定
        tooltips:false,
        // {
        //   callbacks:{
        //       label: function (tooltipItem, data) {
        //     return data.labels[tooltipItem.index]+ ": "+ data.datasets[0].data[tooltipItem.index] + "%";//%を最後につける
        //   }
        //   },    
        // },
        //上部タイトル表示の設定
        title:{
          display: false,
        },
      }
    });
  }
});